import { useState, useEffect } from "react";
import { apiGet, apiSend, errorMessage } from "./api";
import "./CreateUserModal.css";

function CreateCardModal({ onClose, onCreated }) {
  const [orgs, setOrgs] = useState([]);
  const [form, setForm] = useState({
    id: "",
    id_organization: "",
    name: "",
    surname: "",
    email: "",
    phone: "",
    points: 0,
    platform: "Android",
    status: "active",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    apiGet("/api/organizations")
      .then((data) => {
        setOrgs(data);
        if (data.length > 0) setForm((f) => ({ ...f, id_organization: data[0].id }));
      })
      .catch(() => setOrgs([]));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await apiSend("/api/cards", "POST", {
        ...form,
        id_organization: parseInt(form.id_organization),
        // Champ vidé → NaN → 422 : on retombe sur 0
        points: parseInt(form.points) || 0,
      }, "Erreur lors de la création");
      onCreated();
      return;
    } catch (e) {
      setError(errorMessage(e, "Erreur lors de la création"));
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Créer une carte</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}
          <label>Identifiant carte</label>
          <input name="id" value={form.id} onChange={handleChange} placeholder="CARD-XXX" required />
          <label>Organisation</label>
          <select name="id_organization" value={form.id_organization} onChange={handleChange} required>
            {orgs.map((o) => (
              <option key={o.id} value={o.id}>{o.name}</option>
            ))}
          </select>
          <label>Nom</label>
          <input name="name" value={form.name} onChange={handleChange} required />
          <label>Prénom</label>
          <input name="surname" value={form.surname} onChange={handleChange} required />
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} required />
          <label>Téléphone</label>
          <input name="phone" value={form.phone} onChange={handleChange} />
          <label>Points</label>
          <input name="points" type="number" value={form.points} onChange={handleChange} min="0" />
          <label>Plateforme</label>
          <select name="platform" value={form.platform} onChange={handleChange}>
            <option value="Android">Android</option>
            <option value="Apple">Apple</option>
          </select>
          <label>Statut</label>
          <select name="status" value={form.status} onChange={handleChange}>
            <option value="active">Active</option>
            <option value="disabled">Disabled</option>
            <option value="banned">Banned</option>
          </select>
          <button type="submit" className="modal-submit" disabled={loading}>
            {loading ? "Création..." : "Créer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateCardModal;
